import React from "react";
import { useStore } from "utils/useStore";
import { observer } from "mobx-react";
import parser from "html-react-parser";
import { ChatSearchResult } from "components/Evaluation/Stores/EvalStore";
import { getSpeakerColorByChannelOrPersona } from "Theme/utils";
import { AcxTranscriptionStore } from "../AcxTranscription/Stores/AcxTranscriptionStore";
import { SpeakerStore } from "../AcxTranscription/Stores/SpeakerStore/SpeakerStore";
import { ChatPersona, IChatRecord } from "./AcxChatViewer";
import { ConversationSearch } from "../ConversationSearch/ConversationSearch";
import moment from "moment";

export default observer(function InputSearchChat({
    alignment = "right",
    disabled = false,
    inputWidth = "280px",
    onResultClick,
    transcriptionMessages,
}: {
    alignment?: "left" | "right";
    disabled?: boolean;
    inputWidth?: string;
    speakerStore: SpeakerStore;
    onResultClick?: (searchResult: ChatSearchResult) => void;
    transcriptionMessages: IChatRecord[];
}) {
    const store = useStore(AcxTranscriptionStore);
    const searchResults = store.getChatSearchResults(transcriptionMessages);

    return (
        <ConversationSearch
            alignment={alignment}
            disabled={disabled}
            inputWidth={inputWidth}
            searchString={store.searchString}
            onSearchStringChange={(value) => {
                store.searchString = value;
            }}
            results={(searchResults ?? []).map((result, index) => ({
                key: index,
                speaker: result.text
                    ? result.from === ChatPersona.Agent
                        ? "Agent"
                        : "Customer"
                    : undefined,
                speakerColor: getSpeakerColorByChannelOrPersona(result.from),
                timestamp: moment(result.timestamp).format("h:mm A"),
                content: parser(store.formatTextWithHighlights(result.text)),
                onSelect: () => {
                    document.getElementById(result.timestamp)?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                    onResultClick?.(result);
                },
            }))}
        />
    );
});
